import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Storage } from '@ionic/storage';

export interface Novedad {
  id: string;
  fecha: string;
  titulo: string;
  descripcion: string;
  tipo: 'nuevo' | 'mejora' | 'fix';
}

const STORAGE_KEY_ULTIMA_NOVEDAD_VISTA = 'novedades_ultima_vista_id';

@Injectable()
export class NovedadesProvider {
  private cache: Novedad[] = null;

  constructor(private http: HttpClient, private storage: Storage) {}

  private cargarJSON(): Promise<Novedad[]> {
    if (this.cache) { return Promise.resolve(this.cache); }
    return this.http.get<Novedad[]>('assets/data/novedades.json').toPromise()
      .then((data) => {
        this.cache = (data || []).slice().sort((a, b) => b.fecha.localeCompare(a.fecha));
        return this.cache;
      })
      .catch((err) => { console.error('No se pudo cargar novedades.json', err); return []; });
  }

  getHistorialCompleto(): Promise<Novedad[]> {
    return this.cargarJSON();
  }

  async getNoVistas(): Promise<Novedad[]> {
    const todas = await this.cargarJSON();
    const ultimaVistaId = await this.storage.get(STORAGE_KEY_ULTIMA_NOVEDAD_VISTA);
    if (!ultimaVistaId) { return todas; }
    const idx = todas.findIndex(n => n.id === ultimaVistaId);
    if (idx === -1) { return []; }
    return todas.slice(0, idx);
  }

  async marcarComoVistas(): Promise<void> {
    const todas = await this.cargarJSON();
    if (todas.length === 0) { return; }
    await this.storage.set(STORAGE_KEY_ULTIMA_NOVEDAD_VISTA, todas[0].id);
  }
}



// WEBPACK FOOTER //
// ./src/providers/novedades/novedades.ts